"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const _1 = require(".");
const core_1 = require("@material-ui/core");
const Wrapper = ({ children, isFetching, navBar, container = true, }) => (react_1.default.createElement(_1.ThemeWrapper, null,
    react_1.default.createElement(react_1.default.Fragment, null,
        navBar,
        react_1.default.createElement(core_1.Box, { className: 'wrapper', style: {
                minHeight: 'calc(100vh - 100px)',
                backgroundColor: '#F1F2F5',
            }, pb: 4 }, container ? (react_1.default.createElement(core_1.Container, { maxWidth: "lg", className: 'root-container' }, children)) : (react_1.default.createElement(react_1.default.Fragment, null, children))),
        react_1.default.createElement(core_1.Box, null,
            react_1.default.createElement(_1.Footer, { links: [
                    { href: '#', label: 'Contact' },
                    { href: '#', label: 'Sitemap' },
                    { href: '#', label: 'Policy' },
                    { href: '#', label: 'Privacy' },
                ], isHidden: isFetching })))));
Wrapper.propTypes = {
    children: prop_types_1.default.object.isRequired,
    container: prop_types_1.default.bool,
    isFetching: prop_types_1.default.bool,
    navBar: prop_types_1.default.object.isRequired,
};
exports.default = Wrapper;
